$(document).ready(function() {
    var canvases = document.querySelectorAll('.canvas');

    canvases.forEach(function(canvas) {
        var ctx = canvas.getContext('2d');
        canvas.width = 1000;
        canvas.height = 1000;

        var party = smokemachine(ctx, [200, 200, 200]);
        party.start();
        party.addSmoke(500, 500, 10);
        party.setPreDrawCallback(function (dt) {
            party.addSmoke(innerWidth / 2, innerHeight, .1);
            canvas.width = innerWidth;
            canvas.height = innerHeight;
        });
    });
});
